import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { archiveAntragSaga } from "./archiveAntragSaga";

const archiveModule = (): Module => ({
	id: "archiveModule",
	sagas: () => [archiveAntragSaga]
});

export default archiveModule;
